import Siprec from './factory/Siprec'
import Locale from '@/locale'

export default Siprec({
  name: 'recordingRequests',
  enums: {
    operation: {
      DELETE: Locale.t('recordingRequests.operation.delete'),
      PLAY: Locale.t('recordingRequests.operation.play'),
      DOWNLOAD: Locale.t('recordingRequests.operation.download')
    }
  }
})



// WEBPACK FOOTER //
// ./src/models/RecordingRequest.js